'use client';

import { useEffect, useState, useRef } from 'react';

export const TimeBound = ({
  children,
  duration = 3000,
  startNow = false,
  timerExpiryCallback = () => {},
}) => {
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    // If startNow is true, reset timer
    setVisible(true); // Make sure it's visible
    if (startNow) {
      console.log('Starting timer now');
      clearTimeout(timerRef.current); // Clear existing timer

      timerRef.current = setTimeout(() => {
        setVisible(false);
        timerExpiryCallback();
      }, duration);
    }

    return () => {
      timerExpiryCallback();
      clearTimeout(timerRef.current); // Cleanup on unmount
    };
  }, [startNow, duration]);

  if (!visible) return null;

  return <>{children}</>;
};
